import {SliderValueType} from './types';

export const checkValidMinMaxProps = ({
  min,
  max,
}: {
  min: number;
  max: number;
}): void => {
  if (min >= max) {
    throw new Error(
      'DoubleRange - min prop is equal or greater than max prop, this is currently not supported.',
    );
  }
};

export const checkValidValues = (values: SliderValueType): void => {
  if (values[0] > values[1]) {
    throw new Error(
      `DoubleRange - The minimum provided value is greater or equal than the maximum provided value. This is currently not supported. Minimum value \`${values[0]}\`; Maximum value \`${values[1]}\``,
    );
  }
};
